import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
// import classNames from 'classnames';
import _ from 'lodash';

import {
  profileErrorsSelector,
  profileSelector,
  setProfileErrors,
  updateProfile,
} from 'src/store/profile';
import { logoutUser } from 'src/store/auth';

import { CustomButton, CustomInput, WhiteCard } from 'src/components';

import { CalendarIcon } from 'src/assets';
import { ReactComponent as LogoutIcon } from 'src/assets/overall/LogoutIcon.svg';
// import { ReactComponent as EditIcon } from 'src/assets/overall/EditIcon.svg';

import './profile.scss';

export const Profile = () => {
  const { t } = useTranslation('profile');

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const profile = useSelector(profileSelector);
  const formError = useSelector(profileErrorsSelector);

  const [formData, setFormData] = useState({
    login: '',
    email: '',
    password: '',
    password_confirmation: '',
  });
  const [originalForm, setOriginalForm] = useState({
    login: '',
    email: '',
    password: '',
    password_confirmation: '',
  });

  useEffect(() => {
    if (!_.isEmpty(profile)) {
      setFormData((prev) => ({ ...prev, ...profile }));
      setOriginalForm((prev) => ({ ...prev, ...profile }));
    }
  }, [profile]);

  const onClickLogout = useCallback(() => {
    dispatch(logoutUser({ navigate }));
  }, [dispatch, navigate]);

  const onSubmitForm = useCallback(
    async (event) => {
      event.preventDefault();

      const payload = {
        email: formData?.email,
        login: formData?.login,
        ...(formData?.password ? { password: formData?.password } : {}),
        ...(formData?.password_confirmation
          ? { password_confirmation: formData?.password_confirmation }
          : {}),
      };

      await dispatch(updateProfile(payload));
    },
    [dispatch, formData],
  );

  const onChangeInput = useCallback(
    (key) => (event) => {
      setFormData((prev) => ({ ...prev, [key]: event.target.value }));

      const copiedErrors = _.cloneDeep(formError);

      delete copiedErrors?.[key];

      dispatch(setProfileErrors(copiedErrors));
    },
    [dispatch, formError],
  );

  const onCloseChangePassword = useCallback(() => {
    setFormData(originalForm);
    dispatch(setProfileErrors({}));
  }, [dispatch, originalForm]);

  // const renderStyles = useCallback((condition) => {
  //   const styles = classNames({
  //     'profile__header--green': condition,
  //     'profile__header--red': !condition,
  //   });

  //   return styles;
  // }, []);

  const isChangedData = !_.isEqual(formData, originalForm);

  return (
    <div className="profile">
      <div className="profile__header">
        <div className="profile__header__left">
          <h2>{t('title')}</h2>
          {/* <div className="profile__header__item">
            <img src={VerifyIcon} alt={VerifyIcon} />
            <h5>
              {t('verification')}
              {': '}
              <span className={renderStyles(profileData?.verified)}>
                {profileData?.verified ? t('verified') : t('nonVerified')}
              </span>
            </h5>
          </div> */}
          {/* <CustomButton title={t('title:start')} variant="filled" /> */}
        </div>

        <div className="profile__header__right">
          <CustomButton
            title={t('title:logOut')}
            variant="filled"
            color="red"
            icon={<LogoutIcon />}
            iconPosition="right"
            onClick={onClickLogout}
          />
        </div>
      </div>
      <div className="profile__info">
        <WhiteCard>
          <div className="profile__info__item">
            <img src={CalendarIcon} alt={CalendarIcon} />
            <span>
              {t('registerDate')} {profile?.created_at}
            </span>
          </div>
          {/* <div className="profile__info__item">
            <img src={OverallIcon} alt={OverallIcon} />
            <span>
              {t('overallCount')}{' '}
              <strong className={renderStyles(true)}>{profileData.overallCount}</strong>
            </span>
          </div>
          <div className="profile__info__item">
            <img src={DiscountIcon} alt={DiscountIcon} />
            <span>
              {t('discount')}{' '}
              <strong className={renderStyles(false)}>{profileData.discount}</strong>
            </span>
          </div> */}
        </WhiteCard>
      </div>
      <div className="profile__content">
        <WhiteCard>
          <form className="profile__form" onSubmit={onSubmitForm}>
            <div className="profile__form__wrapper">
              <div className="profile__form__row">
                <CustomInput
                  label={t('personalAccount:login')}
                  value={formData?.login}
                  onChange={onChangeInput('login')}
                  errorMessage={formError?.login}
                />
                <CustomInput
                  label={t('personalAccount:email')}
                  type="email"
                  value={formData?.email}
                  onChange={onChangeInput('email')}
                  errorMessage={formError?.email}
                />
              </div>
              <div className="profile__form__row">
                <CustomInput
                  label={t('personalAccount:newPassword')}
                  value={formData?.password}
                  onChange={onChangeInput('password')}
                  errorMessage={formError?.password}
                  type="password"
                />
                <CustomInput
                  label={t('personalAccount:confirmPassword')}
                  value={formData?.password_confirmation}
                  onChange={onChangeInput('password_confirmation')}
                  errorMessage={formError?.password_confirmation}
                  type="password"
                />
              </div>
            </div>

            {isChangedData ? (
              <div className="profile__form__footer">
                <CustomButton title={t('title:save')} variant="filled" type="submit" />
                <CustomButton
                  title={t('title:decline')}
                  type="button"
                  variant="filled"
                  color="red"
                  onClick={onCloseChangePassword}
                />
              </div>
            ) : null}
          </form>
        </WhiteCard>
      </div>
    </div>
  );
};
